/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["mn.", "mg.", "fm.", "em.", "kv.", "nt."], ["midn.", "morg.", "form.", "etterm.", "kveld", "natt"], ["midnatt", "på morgonen", "på formiddagen", "på ettermiddagen", "på kvelden", "på natta"]], [["mn.", "mg.", "fm.", "em.", "kv.", "nt."], ["midn.", "morg.", "form.", "etterm.", "kveld", "natt"], ["midnatt", "morgon", "formiddag", "ettermiddag", "kveld", "natt"]], ["00:00", ["06:00", "10:00"], ["10:00", "12:00"], ["12:00", "18:00"], ["18:00", "24:00"], ["00:00", "06:00"]]];
